import React from 'react'
import {AtollonProvider} from "../../plugins/gatsby-plugin-atollon";
import '../assets/scss/main.scss'

import Header from '../components/header'
import Footer from '../components/footer'
import useLayoutQuery from "../hooks/use-layout-query";
import FormComponent from '../components/form'

import Lenis from "@studio-freight/lenis"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const Layout = (props) => {

    const globalData = useLayoutQuery()
    const { datoCmsForm } = globalData

    const [subscribe, setSubscribe] = React.useState(false)

    React.useEffect(() => {
        const lenis = new Lenis()
        lenis.on("scroll", (e) => {})
        lenis.on("scroll", ScrollTrigger.update)
        const updateLenis = (time) => {
          lenis.raf(time * 1000)
        }
        gsap.ticker.add(updateLenis)
        gsap.ticker.lagSmoothing(0)
  
        return () => {
          gsap.ticker.remove(updateLenis)
          lenis.destroy()
        }
      }, [props.location.pathname]);

    return (
        <AtollonProvider {...props} globalData={globalData}>
            <Header subscribe={subscribe} setSubscribe={setSubscribe} />
            <main className={`${subscribe ? 'subscribe-active' : ''}`}>
              { props.children }
            </main>
            <Footer subscribe={subscribe} setSubscribe={setSubscribe} />
            <section className={`subscribe${subscribe ? ' active' : ''}`}>
              <div className='subscribe__wrapper'>
                <div className='subscribe__content'>
                  <p>Our new site is coming soon – stay connected with us to be notified of our launch and receive exclusive updates.</p>
                </div>
                <div className='subscribe__form'>
                  <FormComponent form={datoCmsForm} />
                </div>
              </div>
            </section>
        </AtollonProvider>
    )
}

export default Layout
